import React, { FunctionComponent } from 'react';
import { LinearProgress, Stack } from '@mui/material';
import { LectionSlideDto } from '../../dto/LectionImageDto';
import { calcProgress2 } from '../../utils/utils';

interface Props {
  curStep: number;
  curSlide: number;
  dtos: LectionSlideDto[];
  color: string;
  background: string;
}

export const LectionDivProgres2Item: FunctionComponent<Props> = ({
  curStep,
  curSlide,
  dtos,
  color,
  background,
}) => (
  <Stack direction="row" spacing={0.5}>
    {dtos.map((item, index) => (
      <LinearProgress
        key={item.id}
        style={{
          background,
          width: '100%',
          borderRadius: '1px',
        }}
        sx={{
          '& .MuiLinearProgress-barColorPrimary': { backgroundColor: color },
        }}
        variant="determinate"
        value={calcProgress2(curStep, item.slideImages.length, curSlide, index)}
      />
    ))}
  </Stack>
);
